import React from "react";
import {
  UserNoticeBlockContainer,
  UserNoticeBlockDesc,
  UserNoticeBlockImage,
  UserNoticeDetails,
  UserNoticeEmptySlotTitle,
  UserNoticeEmptySlotSubTitle,
  UserNoticeMessage,
  UserNoticeEmptyContainer
} from "./user-notice.styles";

import { UserNoticeProps } from "./user-notice.types";
import { Button } from "components/atoms/button/button";
import { Spacer, SPACER_DIRECTION } from "styles/common/spacer";
import { UserNoticeData } from "./user-notice.data";
import { TrialActivationModal } from "../trial-activation-modal/trial-activation-modal";
import { useRouter } from "next/router";
import { SubscriptionType } from "services/api/sessions/sessionService.types";
import { constants } from "constants/constants";
import { useTrialActivationModal } from "../trial-activation-modal/use-trial-activation";
import { CocoHappy } from "./assets/coco-happy";
import Image from "next/legacy/image";
import NaraDetective from "public/assets/kelas-live/nara-detective.svg";

const UserNotice: React.FC<UserNoticeProps> = ({
  primaryUser,
  subscriptionStatus
}) => {
  const subscriptionType = subscriptionStatus.subscriptionType;
  const userName = primaryUser.full_name;
  const userNoticeData = UserNoticeData[subscriptionType];

  const router = useRouter();
  const { showTrialActivation, setShowTrialActivation } =
    useTrialActivationModal(primaryUser.access_token);

  const handleActionButton = () => {
    /* istanbul ignore if -- FREE users never reach this component (see #804); dead branch */
    if (subscriptionType === SubscriptionType.FREE) {
      setShowTrialActivation.on();
    } else {
      router.push({ pathname: constants.redirect_to.paket });
    }
  };

  const getDaysLeft = () => {
    if (
      subscriptionStatus.subscriptionType === SubscriptionType.TRIAL ||
      subscriptionStatus.subscriptionType === SubscriptionType.PAID
    ) {
      return subscriptionStatus.daysLeft;
    }
  };

  const daysLeft = getDaysLeft();

  /* istanbul ignore next -- showComponent is only called inside the non-PAID block, so its PAID sub-conditions and the false return are unreachable */
  const showComponent = () => {
    if (
      subscriptionStatus.subscriptionType !== SubscriptionType.PAID ||
      (subscriptionStatus.subscriptionType === SubscriptionType.PAID &&
        daysLeft &&
        daysLeft < 15)
    ) {
      return true;
    }
    return false;
  };

  return (
    <>
      {subscriptionStatus.subscriptionType !== SubscriptionType.PAID && (
        <UserNoticeBlockContainer
          backgroundColor={userNoticeData.backgroundColor(daysLeft)}
        >
          <UserNoticeBlockImage>
            {
              /* istanbul ignore next -- showComponent is always true inside the non-PAID block */
              showComponent() ? <userNoticeData.mascotImage /> : <CocoHappy />
            }
          </UserNoticeBlockImage>
          <UserNoticeBlockDesc>
            <UserNoticeDetails color={userNoticeData.color}>
              {userNoticeData.title({
                userName,
                daysLeft: daysLeft ? daysLeft : undefined
              })}
            </UserNoticeDetails>
            <UserNoticeMessage color={userNoticeData.color}>
              {userNoticeData.desc(daysLeft)}
            </UserNoticeMessage>
          </UserNoticeBlockDesc>
          {showComponent() && userNoticeData.actionButtonText && (
            <Button variant="primary" onClick={handleActionButton}>
              {userNoticeData.actionButtonText}
            </Button>
          )}
          <Spacer direction={SPACER_DIRECTION.HORIZONTAL} token={[0, 0, 16]} />
        </UserNoticeBlockContainer>
      )}
      {
        /* istanbul ignore next -- only shown via the dead FREE trial-activation path */
        showTrialActivation && (
          <TrialActivationModal
            onClose={() => setShowTrialActivation.off()}
            primaryUser={primaryUser}
            subscriptionStatus={subscriptionStatus}
          />
        )
      }

      {subscriptionStatus.subscriptionType === SubscriptionType.PAID &&
        subscriptionStatus.subscribedCourses?.length === 0 && (
          <UserNoticeEmptyContainer>
            <Image
              src={NaraDetective}
              height={300}
              width={300}
              alt="Nara as detective"
            />
            <UserNoticeEmptySlotTitle>
              Hai CoFriends, kamu belum pilih jadwal nih
            </UserNoticeEmptySlotTitle>
            <UserNoticeEmptySlotSubTitle>
              Pilih jadwal dulu lewat aplikasi CoLearn atau chat Kakak Siaga di
              081119954075.
            </UserNoticeEmptySlotSubTitle>
          </UserNoticeEmptyContainer>
        )}
    </>
  );
};

export { UserNotice };
